import type { ReissueStatusType } from '../../PrescriptionPad';
import { PrescriptionItemAlertType } from '../PrescriptionItemEditor.types';

export type AvailabilityAlertType =
  | PrescriptionItemAlertType.INACTIVE
  | PrescriptionItemAlertType.DISCONTINUED
  | PrescriptionItemAlertType.OUT_OF_STOCK
  | PrescriptionItemAlertType.UNAVAILABLE;

/**
 * The single availability problem to report for a product, or null when it can be prescribed as-is.
 * A product can carry several flags at once, so the order here decides which one the doctor is told about.
 */
export const getAvailabilityAlertType = (
  status: Partial<ReissueStatusType> | undefined,
): AvailabilityAlertType | null => {
  if (!status) {
    return null;
  }
  if (status.isActive === false) {
    return PrescriptionItemAlertType.INACTIVE;
  }
  if (status.isDiscontinued) {
    return PrescriptionItemAlertType.DISCONTINUED;
  }
  if (status.isOutOfStock) {
    return PrescriptionItemAlertType.OUT_OF_STOCK;
  }
  if (status.isUnavailable) {
    return PrescriptionItemAlertType.UNAVAILABLE;
  }
  return null;
};
